import React, { Component } from 'react';
import { connect } from 'react-redux';

import Header from './partials/Header';
import Footer from './partials/Footer';
import TopBar from './partials/TopBar';
import Nav from './partials/Nav';

import Alert from 'react-s-alert';
import * as Actions from './Actions';
import withRouter from 'react-router/lib/withRouter';

import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';
import './assets/css/index.css';
import './assets/css/flag-icon.min.css';

class App extends Component {

    componentWillMount() {
        const { getSports, isLogin } = this.props;
        getSports();
        isLogin();
    }

    componentDidMount() {
        document.body.addEventListener('click', this.bodyClick);
    }

    bodyClick = (e) => {
        if(e.target.className.indexOf('dropdown-toggle') < 0) {
            const { openTopnav } = this.props;
            openTopnav(false);
        }
    }
    
    render() {
        const { children, sports, params, isLoggedIn, location } = this.props;
        
        return (
            <div>
                <TopBar/>
                <Header isLogin={ isLoggedIn }/>
                <Nav sports={ sports } page={params.page}/>

                <div className="border-top"></div>
                <div className="container">
                    { children }
                </div>
                <Footer location={location}/>
                <Alert stack={{ limit: 1 }} effect="slide" />
            </div>
        );
    }
}

export default withRouter(connect(
    (state, routeParams) => {
        const { sports } = state.navMenu;
        const { params, location } = routeParams;
        const { isLoggedIn } = state.bootstrap;

        return {
            sports,
            params,
            isLoggedIn,
            location
        }
    },
    Actions
)(App))




// WEBPACK FOOTER //
// ./src/App.js